import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { LogoBuild } from "./LogoBuild";

const SHOW_MS = 1900;
const reduced = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export const PageLoader = () => {
  const { pathname } = useLocation();
  const [key, setKey] = useState(null);
  const prev = useRef(null);

  useEffect(() => {
    if (prev.current === pathname) return;
    const wasFirst = prev.current === null;
    prev.current = pathname;
    if (wasFirst || reduced()) return;
    setKey(pathname + Date.now());
  }, [pathname]);

  useEffect(() => {
    if (!key) return undefined;
    const t = setTimeout(() => setKey(null), SHOW_MS);
    return () => clearTimeout(t);
  }, [key]);

  return (
    <AnimatePresence>
      {key && (
        <motion.div key={key} data-testid="page-loader" className="fixed inset-0 z-[90]" initial={{ opacity: 1 }} exit={{ opacity: 0, filter: "blur(10px)", scale: 1.04 }} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
          <LogoBuild s={0.36} compact testId="page-loader-logo" />
        </motion.div>
      )}
    </AnimatePresence>
  );
};
